import { faAngleRight, faAngleLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { getMovies } from '../../../api';
import ImageLoader from '../../../common/ImageLoader';
import SearchBar from '../../../common/SearchBar';
import useRouteStore from '../../../hooks/useRouteStore';

const AdminMovies = () => {
  const [movies, setMovies] = useState({});
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [maxPage, setMaxPage] = useState(1);
  const [pageSize, setPageSize] = useState({ value: '20', label: '20' });
  const [page, setPage] = useState(1);
  const setRoute = useRouteStore((state) => state.setRoute);

  const elementsOptions = [
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
  ];

  useEffect(() => {
    setRoute([
      { name: 'Inicio', url: '/administracion' },
      { name: 'Películas', url: '/administracion/peliculas' },
    ]);
    setLoading(true);
    getMovies({ full: true, limit: pageSize.value, page, search: query }).then((res) => {
      setMovies(res.data.movies);
      setMaxPage(res.data.maxPage);
      setLoading(false);
    });
  }, [page, query, pageSize]);

  const handleDecreasePage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleIncreasePage = () => {
    if (page < maxPage) {
      setPage(page + 1);
    }
  };

  const handleSearch = () => {
    if (search.trim() !== query) {
      setQuery(search.trim() || '');
      setPage(1);
    }
  };

  const handleChangePageSize = (value) => {
    setPageSize(value);
    setPage(1);
  };

  return (
    <div className='font-montserrat w-full max-h-full'>
      <h1 className='font-semibold text-xl'>Películas</h1>
      <div className='flex flex-col md:flex-row justify-between my-1 w-full mx-1'>
        <div className='w-full md:w-1/2'>
          <SearchBar value={search} setValue={setSearch} onSubmit={handleSearch} className='w-full' autoSubmit />
        </div>
        <div className='flex items-center gap-3 w-full md:w-fit'>
          <span className='block whitespace-nowrap'>Tamaño página:</span>
          <Select options={elementsOptions} value={pageSize} onChange={handleChangePageSize} className='w-full md:w-24 mt-4 md:mt-0' />
          <Link
            to='/administracion/peliculas/nueva'
            className='flex items-center bg-red-1 p-1 px-2 rounded text-white shadow font-semibold h-full hover:bg-white hover:text-green-500 transition-all'
          >
            <FontAwesomeIcon icon={faPlus} />
            <span>&nbsp;Nueva película</span>
          </Link>
        </div>
      </div>
      <div className='flex mt-2'>
        <div className='grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 w-full text-center border-r-2'>
          <div className='col-span-1'></div>
          <div className='col-span-3 text-center border-l-2 md:border-r-2'>Titulo original</div>
          <div className='hidden lg:block col-span-2 text-center'>Visibilidad</div>
        </div>
      </div>
      <div className='flex flex-col mt-2 gap-3 max-w-full'>
        {!loading ? (
          movies.map((movie, index) => {
            return (
              <Link
                to={'/administracion/peliculas/' + movie._id}
                key={index}
                className='flex items-center p-2 rounded-lg bg-red-2 bg-opacity-5 hover:ring-1 transition-all font-semibold'
              >
                <div className='grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 w-full'>
                  <div className='col-span-1 text-center my-auto'>
                    <div className='h-14 w-48 overflow-hidden hover:overflow-visible hover:z-10 relative hover:shadow-xl rounded transition-all'>
                      <ImageLoader src={movie.imagen_catalogo} className='object-cover' />
                    </div>
                  </div>
                  <div className='col-span-3 text-center my-auto'>{movie.titulo_original}</div>
                  <div className='hidden lg:block col-span-2 text-center my-auto'>{movie.publicada ? 'Visible' : 'Oculto'}</div>
                </div>
              </Link>
            );
          })
        ) : (
          <div className='h-14 mt-20'>
            <span className='loader2'></span>
          </div>
        )}
      </div>
      <div className='grid grid-cols-3 w-fit mr-0 ml-auto'>
        <button onClick={handleDecreasePage} className={(page !== 1 ? 'text-red-1 ' : 'text-slate-400 ') + 'w-14 h-14 text-xl'}>
          <FontAwesomeIcon icon={faAngleLeft} />
        </button>
        <div className='flex justify-center items-center'>{page}</div>
        <button onClick={handleIncreasePage} className={(maxPage > page ? 'text-red-1 ' : 'text-slate-400 ') + 'w-14 h-14 text-xl'}>
          <FontAwesomeIcon icon={faAngleRight} />
        </button>
      </div>
    </div>
  );
};

export default AdminMovies;
